// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uZeW","textarea":"styles_textarea__bTYsF"};